export default "__VITE_ASSET__ea081bde__"